module.exports = __webpack_public_path__ + "static/media/wv-logo-2022.6eaa14e5.png";